import { send } from "../dataProvider/contact";

export const sendContact = (contact) => () => send(contact);
